import React, { FC, ChangeEvent } from 'react';

import { useGeo } from '../../../context';

interface Props {
	locked: string;
	rowItem: { id: string; value: any; inherited: any };
}
export const ReferenceFieldAppend: FC<Props> = ({ locked, rowItem }) => {
	const { updateGeoParameters } = useGeo();
	const { id, value, inherited } = rowItem;

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const val = e.currentTarget.value === '' ? undefined : e.currentTarget.value;
		updateGeoParameters(id, val);
	};
	return (
		<div className="value_content">
			<input
				id={id}
				name={id}
				type="text"
				onChange={handleChange}
				value={value == null ? '' : value}
				className={`normal margin_bottom_10 full_w ${locked}`}
			/>
			<input
				id={id}
				name={id}
				type="text"
				onChange={() => {}}
				value={inherited == null ? '' : inherited}
				className={`normal  full_w disabled`}
			/>
		</div>
	);
};
